import { render, staticRenderFns } from "./myTabbar.vue?vue&type=template&id=271a2cf4&scoped=true"
import script from "./myTabbar.vue?vue&type=script&lang=js"
export * from "./myTabbar.vue?vue&type=script&lang=js"
import style0 from "./myTabbar.vue?vue&type=style&index=0&id=271a2cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a2cf4",
  null
  
)

export default component.exports